import axiosInstance from "./axiosInstance";

// Get all news
export const getNews = async () => {
  const response = await axiosInstance.get("/sheets/news");
  return response.data;
};

// // Get single news article
// export const getNewsById = async (id) => {
//   const response = await axiosInstance.get(`/sheets/news/${id}`);
//   return response.data;
// };

// // Create new news article
// export const createNews = async (newsData) => {
//   const response = await axiosInstance.post("/sheets/news", newsData);
//   return response.data;
// };
